import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import type { AdminServicesStateData } from "@/types/catalog"

export type AdminServicesState = {
  data: AdminServicesStateData
  error: string | null
}

export const adminServicesInitialState: AdminServicesState = {
  data: {
    services: [],
    pagination: {
      pageNumber: 1,
      pageSize: 10,
      totalElements: 0,
      totalPages: 0,
    },
  },
  error: null,
}

const slice = createSlice({
  name: "adminServices",
  initialState: adminServicesInitialState,
  reducers: {
    setAdminServicesAction(state, { payload }: PayloadAction<AdminServicesStateData>) {
      state.data = payload
      state.error = null
    },
    setAdminServicesErrorAction(state, { payload }: PayloadAction<string | null>) {
      state.error = payload
    },
  },
})

export const { setAdminServicesAction, setAdminServicesErrorAction } = slice.actions
export default slice.reducer
